import React from "react";

const TermsFooter = () => (
  <div className="terms-footer">
    <div className="terms-footer-logo-list-wrapper">
      <a
        target="__blank"
        href="https://world.hyatt.com/content/gp/en/landing/brand-explorer-award.html"
      >
        <img
          className="terms-footer-logo-list--top"
          src="/assets/logos/world-of-hyatt.svg"
          alt=""
        />
      </a>

      <div className="terms-footer-logo-list-container">
        <div className="group">
          <div className="group-name">
            <div className="group-name__text">LUXURY</div>
          </div>
          <div className="group-logos">
            <a
              target="__blank"
              className="group-logos__logo"
              href="https://www.hyatt.com/brands/park-hyatt"
            >
              <img src="/assets/logos/luxury/park-hyatt.svg" alt="" />
            </a>
            <a
              target="__blank"
              className="group-logos__logo"
              href="https://www.hyatt.com/brands/alila-hotels-and-resorts"
            >
              <img src="/assets/logos/luxury/alila.svg" alt="" />
            </a>
            <a
              target="__blank"
              className="group-logos__logo"
              href="https://www.hyatt.com/brands/unbound-collection"
            >
              <img src="/assets/logos/luxury/unbound.svg" alt="" />
            </a>
          </div>
        </div>
        <div className="group">
          <div className="group-name">
            <div className="group-name__text">Lifestyle</div>
          </div>
          <div className="group-logos">
            <a
              target="__blank"
              className="group-logos__logo"
              href="https://www.hyatt.com/andaz"
            >
              <img src="/assets/logos/lifestyle/andaz.svg" alt="" />
            </a>
            <a
              target="__blank"
              className="group-logos__logo"
              href="https://www.hyatt.com/thompson-hotels"
            >
              <img src="/assets/logos/lifestyle/thompson.svg" alt="" />
            </a>
            <a
              target="__blank"
              className="group-logos__logo"
              href="https://www.standardhotels.com"
            >
              <img src="/assets/logos/lifestyle/standard.svg" alt="" />
            </a>
            <a
              target="__blank"
              className="group-logos__logo"
              href="https://www.standardx.com"
            >
              <img src="/assets/logos/lifestyle/standardx.svg" alt="" />
            </a>
            <a
              target="__blank"
              className="group-logos__logo"
              href="https://www.hyatt.com/brands/jdv-by-hyatt"
            >
              <img src="/assets/logos/lifestyle/jdv.svg" alt="" />
            </a>
          </div>
        </div>
        <div className="group">
          <div className="group-name">
            <div className="group-name__text">Inclusive</div>
          </div>
          <div className="group-logos">
            <a
              target="__blank"
              className="group-logos__logo"
              href="https://www.hyatt.com/destinations/dreams"
            >
              <img
                className="group-logos__logo"
                src="/assets/logos/inclusive/dreams.svg"
                alt=""
              />
            </a>
          </div>
        </div>
        <div className="group">
          <div className="group-name">
            <div className="group-name__text">Classics</div>
          </div>
          <div className="group-logos">
            <a
              target="__blank"
              className="group-logos__logo"
              href="https://www.hyatt.com/brands/grand-hyatt"
            >
              <img src="/assets/logos/classics/grand-hyatt.svg" alt="" />
            </a>
            <a
              target="__blank"
              className="group-logos__logo"
              href="https://www.hyatt.com/hyatt-regency"
            >
              <img src="/assets/logos/classics/hyatt-regency.svg" alt="" />
            </a>
            <a
              target="__blank"
              className="group-logos__logo"
              href="https://www.hyatt.com/brands/hyatt-centric"
            >
              <img src="/assets/logos/classics/hyatt-centric.svg" alt="" />
            </a>
          </div>
        </div>
        <div className="group">
          <div className="group-name">
            <div className="group-name__text">Essentials</div>
          </div>
          <div className="group-logos">
            <a
              target="__blank"
              className="group-logos__logo"
              href="https://www.hyatt.com/brands/caption-by-hyatt"
            >
              <img src="/assets/logos/essentials/caption.svg" alt="" />
            </a>
            <a
              target="__blank"
              className="group-logos__logo"
              href="https://www.hyatt.com/hyatt-place"
            >
              <img src="/assets/logos/essentials/hyatt-place.svg" alt="" />
            </a>
            <a
              target="__blank"
              className="group-logos__logo"
              href="https://www.hyatt.com/hyatt-house"
            >
              <img src="/assets/logos/essentials/hyatt-house.svg" alt="" />
            </a>
            <a
              target="__blank"
              className="group-logos__logo"
              href="https://www.hyatt.com/brands/urcove"
            >
              <img src="/assets/logos/essentials/urcove.svg" alt="" />
            </a>
          </div>
        </div>
      </div>

      <img
        className="terms-footer-logo-list--bottom"
        src="/assets/logos/be-more-here.svg"
        alt=""
      />
    </div>
  </div>
);

export default TermsFooter;
